/**
 * Презентация → GenerationCard: презентации показываются УНИВЕРСАЛЬНЫМ
 * модалом генераций (CardModal), как и остальные результаты — решение
 * владельца 2026-08-07. Отдельный тёмный PresentationPreviewModal удалён.
 */
import type { PresentationItem } from '../api/presentations'
import type { GenerationCard } from '../types/generationCard'

/**
 * Microsoft Office Online Viewer URL для рендера PPTX в iframe.
 * gamma.app напрямую не встраивается (X-Frame-Options: SAMEORIGIN),
 * MS-viewer работает для любой PPTX по presigned URL.
 * action=embedview / wdHideHeaders — просьба минимального MS-хрома
 * (не всегда стабильны, поэтому дополнительно клип в CSS).
 */
export function buildOfficeViewerUrl(pptxUrl: string): string {
	const params = new URLSearchParams({
		src: pptxUrl,
		action: 'embedview',
		wdHideHeaders: 'true',
	})
	return `https://view.officeapps.live.com/op/view.aspx?${params.toString()}`
}

export function presentationToCard(item: PresentationItem): GenerationCard {
	return {
		id: item.id,
		type: 'generation',
		kind: 'presentation',
		// PNG первого слайда (если отрендерился) — превью для лент/фолбэков.
		previewUrl: item.thumbnail_url || '',
		prompt: item.prompt || '',
		promptLocked: item.prompt_hidden,
		userPrompt: item.user_prompt || undefined,
		toolCard: item.tool_card || undefined,
		modelId: item.model || '',
		modelName: item.model || 'Презентация',
		isVideo: false,
		pptxUrl: item.download_url || undefined,
		presentationMode: item.mode,
		createdAt: item.created_at ? Date.parse(item.created_at) : undefined,
		// Оценка 👍/👎 пишется в requests — без request_id кнопки скрыты.
		requestId: item.request_id || undefined,
		// Сохранённая оценка: кнопки при переоткрытии показывают состояние.
		userRating: item.user_rating ?? null,
		title: item.title,
	}
}
